import React from 'react';
import PropTypes from 'prop-types';
import CookieConsent from 'react-cookie-consent';
import './layout.css';
import SEO from './seo';
import Footer from './Footer';
import styled from 'styled-components';
import TopSection from './TopSection';
import { device } from '../providers/theme';
import { Link } from 'gatsby';
import cookieslogo from '../images/iconbig.png';

const Container = styled.div`
  .acceptCookie {
    background: ${props => props.theme.themeColor.primary} !important;
    color: #fff !important;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 32px !important;
    padding: 12px 28px !important;
  }
`;

const Main = styled.main`
  padding: 0 5vw;

  @media ${device.tablet} {
    padding: 0 8px;
  }
`;

const LinkToCookies = styled.a`
  width: 24px;
  height: 24px;
  display: inline-block;
  margin: 0;
`;

const Layout = ({ themeColor, children, title, withoutSeo }) => {
  return (
    <React.Fragment>
      {!withoutSeo && <SEO title={title} />}
      <Container>
        <TopSection themeColor={themeColor || '#722f37'} type={title} />
        <Main>{children}</Main>
        <Footer themeColor={themeColor || '#722f37'} />
        <CookieConsent
          buttonClasses="acceptCookie"
          declineButtonClasses="declineCookie"
          location="bottom"
          buttonText="Accepter"
          cookieName="websiteCookie"
          enableDeclineButton
          contentClasses="cookieContent"
          declineButtonText="Afvis"
          buttonWrapperClasses="actionClasses"
          style={{
            background: '#fff',
            color: '#000',
            borderTop: '1px solid #d8d8d8'
          }}
          expires={150}
        >
          Vi anvender cookies til statistik
          <Link
            style={{
              fontWeight: '300',
              textDecoration: 'underline',
              paddingLeft: 6
            }}
            href="/cookies"
          >
            Læs mere
          </Link>
        </CookieConsent>
      </Container>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
